import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { SupplierLogo } from 'shared/ui/SupplierLogo/ui/SupplierLogo';

interface SupplierCardHeaderProps {
    name: string;
    logo?: string;
    accountNumber?: string;
}

export const SupplierCardHeader = ({
    name,
    logo,
    accountNumber,
}: SupplierCardHeaderProps) => {
    const { t } = useTranslation();

    return (
        <Box
            data-testclass="supplier-card-header"
            sx={{
                display: 'flex',
                alignItems: 'center',
                gap: 1.8,
                mb: '24px',
            }}
        >
            <SupplierLogo
                logo={logo ?? ''}
                title={name}
                size={40}
                sx={{ borderRadius: '4px' }}
            />
            <Box sx={{ flex: 1 }}>
                <Typography
                    typography="openSans.subtitle1"
                    fontSize="14px"
                    fontWeight={600}
                >
                    {name}
                </Typography>
                <Typography
                    typography="openSans.subtitle2"
                    color="grey.600"
                    fontWeight={400}
                >
                    {t('Account')}
                    <Box
                        component="span"
                        sx={{ pl: '8px', color: 'common.black' }}
                    >
                        {accountNumber ?? ''}
                    </Box>
                </Typography>
            </Box>
        </Box>
    );
};
